import React from 'react'
import { useHistory } from 'react-router-dom'

const MemoryChooseSection = ({ activeType, currentImages, t }) => {
    const history = useHistory()
    const onCardClick = product => () => {
        history.push(`/products/memory-games-for-${product}`)
    }

    return (
        <div className="memory-choose-section">
            <div className="memory-choose-section__card" onClick={onCardClick('teachers')}>
                <div className="memory-choose-section__card-text">
                    <div className="memory-choose-section__card-text-header">
                        {t(activeType.texts.chooseSection.forTeachers.header)}
                    </div>
                    <div className="memory-choose-section__card-text-description">
                        {t(activeType.texts.chooseSection.forTeachers.description)}
                    </div>
                </div>
                <div className="memory-choose-section__card-button">
                    <a className="button-style" data-variant="secondary-white">
                        {t(activeType.texts.chooseSection.button)}
                    </a>
                </div>
                <div className="memory-choose-section__card-image">
                    <img alt="" src={currentImages.chooseSection.forTeacherLeft} />
                    <img alt="" src={currentImages.chooseSection.forTeacherRight} />
                </div>
            </div>
            <div className="memory-choose-section__card" onClick={onCardClick('business')}>
                <div className="memory-choose-section__card-text">
                    <div className="memory-choose-section__card-text-header">
                        {t(activeType.texts.chooseSection.forBusiness.header)}
                    </div>
                    <div className="memory-choose-section__card-text-description">
                        {t(activeType.texts.chooseSection.forBusiness.description)}
                    </div>
                </div>
                <div className="memory-choose-section__card-button">
                    <a className="button-style" data-variant="secondary-white">
                        {t(activeType.texts.chooseSection.button)}
                    </a>
                </div>
                <div className="memory-choose-section__card-image">
                    <img alt="" src={currentImages.chooseSection.forBusinessLeft} />
                    <img alt="" src={currentImages.chooseSection.forBusinessRight} />
                </div>
            </div>
        </div>
    )
}

export default MemoryChooseSection
